import {ChangeDetectionStrategy, Component, Inject} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";
import {MatMenuTrigger} from "@angular/material/menu";
import {TranslateModule} from "@ngx-translate/core";
import {ArkivmappeMenyKomponent} from "web-ng2/moduler/arkiv/komponenter/arkivmappe-meny/arkivmappe-meny";
import {BrukerkontekstTilbyder} from "felles-ng2/tjenester/BrukerkontekstTilbyder";
import {DelegerteMappevisningOperasjoner, DelegerteMappevisningOperasjoner_DI_TOKEN, MappevisningBasisKomponent} from "web-ng2/moduler/arkiv/komponenter/mappevisning/MappevisningBasisKomponent";
import {MatTooltip} from "@angular/material/tooltip";

const debug = initDebugger('MappeListevisningKomponent');

/**
 * Visning av arkivmappe for bruk i liste-visning.
 */
@Component({
    selector: 'arkivmappe-listevisning',
    templateUrl: 'arkivmappe-listevisning.html',
    styleUrl: 'arkivmappe-listevisning.scss',
    host: {'data-testid': 'mappe'},
    imports: [
        MatIcon,
        MatIconButton,
        TranslateModule,
        MatMenuTrigger,
        ArkivmappeMenyKomponent,
        MatTooltip
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArkivmappeListevisningKomponent extends MappevisningBasisKomponent {

    constructor(@Inject(DelegerteMappevisningOperasjoner_DI_TOKEN) delegerteOperasjoner: DelegerteMappevisningOperasjoner, kontekst: BrukerkontekstTilbyder) {
        super(delegerteOperasjoner, kontekst);
    }

}
